<template>
	<v-app dark v-if="getItems.length > 0">
		<core-filter />
		<core-toolbar />
		<core-drawer />
		<core-view />

		<!-- Snackbar global para notificaciones -->
		<v-snackbar
			v-model="snackbar"
			:color="message.color"
			:timeout="timeout"
			:bottom="true"
			:right="true"
		>
			{{ message.text }}
			<v-btn dark text @click="snackbar = false">
				Cerrar
			</v-btn>
		</v-snackbar>
	</v-app>
</template>

<script>
import Filter from "~/components/core/Filter.vue";
import Toolbar from "~/components/core/Toolbar.vue";
import Drawer from "~/components/core/Drawer.vue";
import View from "~/components/core/View.vue";

import { mapMutations, mapGetters } from "vuex";

export default {
	name: "layout-dashboard",
	middleware: "auth",

	components: {
		"core-filter": Filter,
		"core-toolbar": Toolbar,
		"core-drawer": Drawer,
		"core-view": View,
	},
	created() {
		try {
			const user = this.getUser;
			if (!user || !user.Level || !user.Level.LevelPrivileges) {
				console.warn('dashboard layout: Usuario no disponible en created');
				this.privileges([]);
				return;
			}
			let items = user.Level.LevelPrivileges.filter((e) => {
				if (e.read) {
					if (e.write) e.Form.write = e.write;
					return e.Form;
				}
			}).map((elem) => elem.Form);
			this.privileges(items);
		} catch (e) {
			console.error('Error en dashboard layout created:', e);
			this.privileges([]);
		}
	},
	data: () => ({
		items: [],
	}),
	methods: {
		...mapMutations({
			privileges: "privileges",
		}),
	},
	computed: {
		...mapGetters("snackbar", [
			"getMessage",
			"getSnackbar",
			"getTimeout"
		]),
		getItems() {
			try {
				const user = this.getUser;
				if (!user || !user.Level || !user.Level.LevelPrivileges) {
					console.warn('getItems: Usuario o Level no disponible');
					return [];
				}
				return user.Level.LevelPrivileges
					.filter((e) => {
						if (e.read) return e.Form;
					})
					.map((elem) => {
						return elem.Form;
					});
			} catch (e) {
				console.error('Error en getItems:', e);
				return [];
			}
		},
		getUser() {
			try {
				return this.$store.getters["loggedInUser"] || { Level: { LevelPrivileges: [] } };
			} catch (e) {
				console.error('Error en getUser:', e);
				return { Level: { LevelPrivileges: [] } };
			}
		},
		snackbar: {
			get() {
				return this.getSnackbar;
			},
			set(value) {
				this.$store.commit("snackbar/setSnackbar", value);
			},
		},
		message: {
			get() {
				return this.getMessage;
			},
		},
		timeout: {
			get() {
				return this.getTimeout;
			},
		},
	},
};
</script>
